import React from 'react';
import cn from 'classnames';

import css from './LiquidGlassEffect.module.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
};

export default function LiquidGlassEffect({ children, className, onClick }: Props) {
  return (
    <div className={cn(css.liquidGlassWrap, className)} onClick={onClick}>
      <div className={css.liquidGlass}>{children}</div>
    </div>
  );
}
